import { combineReducers } from 'redux';

import basicState, { basicInitialState } from './basic';
import builderState, { builderInitialState } from './builder';
import dataVerificationModalState, { dataVerificationModalInitialState } from './dataVerificationModal';
import saveDialogState, { saveDialogInitialState } from './saveDialog';
import shareDialogState, { shareDialogInitialState } from './shareDialog';

export const creatorInitialState =  { 
  basicState: basicInitialState, 
  builderState: builderInitialState,
  dataVerificationModalState: dataVerificationModalInitialState,
  saveDialogState: saveDialogInitialState,
  shareDialogState: shareDialogInitialState,
}

export default combineReducers({ 
  basicState, 
  builderState,
  dataVerificationModalState,
  saveDialogState,
  shareDialogState
})